'use client';

import './search-sidebar.scss';

import {
  Prominence,
  Sizes,
  Text,
  Variants,
} from '@sola/ark-core/atoms/text/text.tsx';
import { NavigationProps } from '@sola/schema/lib/schema.ts';

import { LinkList } from '../../atoms/link-list/link-list.tsx';

export const SearchSidebar = ({
  quickLinksMenu,
}: {
  quickLinksMenu?: NavigationProps;
}) => {
  if (!quickLinksMenu) {
    return;
  }

  return (
    <div className="SearchSidebar flex flex-col gap-comfy-sm">
      <Text
        variant={Variants.Heading}
        prominence={Prominence.Mild}
        size={Sizes.Small}
      >
        {quickLinksMenu.title}
      </Text>
      <LinkList item={quickLinksMenu} />
    </div>
  );
};
